/* 此文件用于创建路由器对象以及配置路由和组件的映射关系 */

import Vue from 'vue'
import VueRouter from 'vue-router'

// 引入路由组件
import Home from '../views/Home'
import order from '../views/order'
import index from '../views/index.vue'
import tasklist from '../views/tasklist'
import reception_hall from '../views/reception_hall'
import usercenter from '../views/usercenter'
import Publish_task from '../views/Publish_task'
import consumer from '../views/consumer'
import endorder from '../views/endorder'
import help_center from '../views/help_center.vue'
import problem from '../views/problem.vue'
import platform_rules from '../views/platform_rules.vue'
import financial from '../views/financial.vue'
import financial_details from '../views/financial_details.vue'
import payment_record from '../views/payment_record.vue'
import recharge_record from '../views/recharge_record.vue'
import withdrawalRecord from '../views/withdrawalRecord.vue'
import message from '../views/message.vue'
import MyHeader from '../components/MyHeader.vue';
import help from '../views/help.vue';
Vue.component('MyHeader', MyHeader);
import MyAside from '../components/MyAside.vue';
import axios from "axios";
Vue.component('MyAside', MyAside);
import store from '@/store';
import { config } from '@/main';
// 如果在一个模块化工程中使用它，必须要通过 Vue.use() 明确地安装路由功能
// 使用 VueRouter 插件，让整个应用支持路由
Vue.use(VueRouter)

const routes = [ // 路由字典/路由规则，里面每一条路由对应一个组件。在这里配置路由和组件的映射关系,一个路由就对应一个对象

    {
        path: '/', // path：路由地址，对于hash路由来说，它本质代表的是hash值
        component: Home,
        meta: { keepAlive: true }
    },
    {
        path: '/home', // path：路由地址，对于hash路由来说，它本质代表的是hash值
        component: Home,
        meta: { keepAlive: true }
    },
    {
        path: '/order',
        component: order,
        meta: { keepAlive: true }
    },
    {
        path: '/index',
        component: index,
        meta: { keepAlive: true }
    },
    {
        path: '/tasklist',
        component: tasklist,
        meta: { keepAlive: true }
    },
    {
        path: '/reception_hall',
        component: reception_hall,
        meta: { keepAlive: true }
    },
    {
        path: '/usercenter',
        component: usercenter,
        meta: { keepAlive: true }
    },
    {
        path: '/Publish_task',
        component: Publish_task,
        meta: { keepAlive: true }
    },
    {
        path: '/consumer',
        component: consumer,
        meta: { keepAlive: true }
    },
    {
        path: '/endorder',
        component: endorder,
        meta: { keepAlive: true }
    },
    {
        path: '/help_center',
        component: help_center,
        meta: { keepAlive: true }
    },
    {
        path: '/problem',
        component: problem,
        meta: { keepAlive: true }
    },
    {
        path: '/platform_rules',
        component: platform_rules,
        meta: { keepAlive: true }
    },{
        path: '/financial',
        component: financial,
        meta: { keepAlive: true }
    },{
        path: '/financial_details',
        component: financial_details,
        meta: { keepAlive: true }
    }, {
        path: '/payment_record',
        component: payment_record,
        meta: { keepAlive: true }
    }, {
        path: '/recharge_record',
        component: recharge_record,
        meta: { keepAlive: true }
    }, {
        path: '/withdrawalRecord',
        component: withdrawalRecord,
        meta: { keepAlive: true }
    },{
        path: '/message',
        component: message,
        meta: { keepAlive: true }
    },{
        path: '/help',
        component: help,
        meta: { keepAlive: true }
    }
]

// 创建 router 实例，然后传入 `routes` 配置，还可以传入其他配置，但是目前不关注(详见Router构建选项)
const router = new VueRouter({
    mode: 'history',
    routes, // 简写：等于 routes:routes
})
router.beforeEach(async (to, from, next) => {
    try {
        // 假设 store.state.userPermissions 和 store.state.userpath 已经在其他地方被正确设置
        // 这里我们只关注检查登录状态和更新页面元信息
        // 发送异步请求以检查登录状态或获取配置信息
        const response = await axios.post(store.state.apiUrl+'/?a=ajax_user&m=islogin');
        const data = response.data;
        // 更新页面标题和 meta 标签
        document.title = data.web_config.web_title;
        const updateMeta = (name, content) => {
            const meta = document.querySelector(`meta[name="${name}"]`);
            if (meta) {
                meta.setAttribute('content', content);
            } else {
                const newMeta = document.createElement('meta');
                newMeta.name = name;
                newMeta.content = content;
                document.head.appendChild(newMeta);
            }
        };
        updateMeta('keywords', data.web_config.web_keyword);
        updateMeta('description', data.web_config.web_description);
        // 根据响应数据决定是否重定向或设置认证状态
        console.log(486)
        if (data.status === 0) {
            if(to.path != '/index'&&to.path != '/help'){
                next({ path: '/index' });
                return;
            }
        } else {
            console.log(486)
            if (data.user.type === '2') {
                store.commit('setAuthentication', true);
                if (to.path === '/Publish_task' || to.path === '/tasklist') {
                    next({ path: '/order' });
                }
                next();
                return;
            } else if (to.path === '/reception_hall') {
                next({ path: '/order' });
                return;
            } else if (to.path === '/index') {
                console.log(486)
                next({ path: '/home' });
                return;
            }
        }
        // 如果上述条件都不满足，则继续当前路由
        next();

    } catch (error) {
        // 处理错误情况
        console.error("There was an error!", error);
        // 可以在这里决定是否重定向到错误页面或进行其他错误处理
        next({ path: '/error' }); // 假设有一个错误页面
    }
});
// 导出路由器对象
export default router
